import { TOOLS } from '@/constants.js'

// Orden de los módulos en radar (columns)
const RADAR_MODULE_ORDER = [TOOLS.SENSORS, TOOLS.CHECKLISTS, TOOLS.PRODUCT_TIMERS, TOOLS.OPERATIONAL_TIMERS, TOOLS.REGISTERS, TOOLS.ACTION_PLANS, TOOLS.ISSUES]

/**
 * Esquema de módulos Radar por código de herramienta (TOOLS.*).
 */
const RADAR_MODULE_SCHEMA = {
    [TOOLS.SENSORS]: {
        key: 'sensors',
        labelKey: 'page_title.Sensor',
        icon: 'i-andy-remote-control-line',
        total: 0,
        apiFormat: 'sensors_object',
        kpis: {
            sensors_with_issues: {
                count: 0,
                icon: 'i-andy-circle-exclamation',
                labelKey: 'config.sensor.issues',
                route: { name: 'Sensor', query: { kpi: 'issues' } },
                criticalCard: {
                    labelKey: 'radar.critical_cards.sensors_with_issues'
                },
                severity: 'critical'
            },
            sensors_without_data: {
                count: 0,
                icon: 'i-andy-no-wifi',
                labelKey: 'sensor.no_data',
                route: { name: 'Sensor', query: { kpi: 'disconnected' } },
                criticalCard: {
                    labelKey: 'radar.critical_cards.sensors_without_data'
                },
                severity: 'critical'
            },
            sensors_with_alert: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'config.sensor.alerts',
                route: { name: 'Sensor', query: { kpi: 'alerts' } },
                severity: 'warning'
            },
            sensors_muted: {
                count: 0,
                icon: 'i-andy-bell-disabled',
                labelKey: 'sensor.offline',
                route: { name: 'Sensor', query: { kpi: 'offline' } },
                criticalCard: {
                    labelKey: 'radar.critical_cards.sensors_muted'
                },
                severity: 'info'
            }
        }
    },
    [TOOLS.CHECKLISTS]: {
        key: 'tasks',
        labelKey: 'page_title.Checklist',
        icon: 'i-andy-menu-checklist',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_length',
        kpis: {
            tasks_to_justify_yesterday: {
                count: 0,
                icon: 'i-andy-circle-exclamation',
                labelKey: 'radar.module_kpis.to_justify_yesterday',
                route: {
                    name: 'Checklist',
                    params: { propDateDaysOffset: -1 }
                },
                criticalCard: {
                    labelKey: 'radar.critical_cards.tasks_to_justify_yesterday'
                },
                severity: 'critical'
            },
            tasks_to_justify_today: {
                count: 0,
                icon: 'i-andy-circle-exclamation',
                labelKey: 'radar.module_kpis.to_justify_today',
                route: {
                    name: 'Checklist'
                },
                criticalCard: {
                    labelKey: 'radar.critical_cards.tasks_to_justify_today'
                },
                severity: 'critical'
            },
            tasks_expiring_soon: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'radar.module_kpis.due_soon',
                route: {
                    name: 'Checklist'
                },
                severity: 'warning'
            }
        }
    },
    [TOOLS.PRODUCT_TIMERS]: {
        key: 'productTimers',
        labelKey: 'page_title.TimersProduct',
        icon: 'i-andy-menu-timer',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_length',
        kpis: {
            product_timers_expired: {
                count: 0,
                icon: 'i-andy-circle-exclamation',
                labelKey: 'radar.module_kpis.expired',
                route: { name: 'TimersProduct' },
                criticalCard: {
                    labelKey: 'radar.critical_cards.product_timers_expired'
                },
                severity: 'critical'
            },
            product_timers_expiring_soon: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'radar.module_kpis.expire_soon',
                route: { name: 'TimersProduct' },
                severity: 'warning'
            }
        }
    },
    [TOOLS.ACTION_PLANS]: {
        key: 'actionPlans',
        labelKey: 'page_title.ActionPlan',
        icon: 'i-andy-menu-audit',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_total_sum',
        kpis: {
            open_action_plans: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'radar.module_kpis.pending_plural',
                route: { name: 'Audit' },
                severity: 'warning'
            }
        }
    },
    [TOOLS.ISSUES]: {
        key: 'incidents',
        labelKey: 'page_title.Issues',
        icon: 'i-andy-menu-task',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_total_sum',
        kpis: {
            open_issues: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'radar.module_kpis.pending_plural',
                route: { name: 'Issues' },
                severity: 'warning'
            }
        }
    },
    [TOOLS.REGISTERS]: {
        key: 'records',
        labelKey: 'page_title.Register',
        icon: 'i-andy-menu-register',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_total_sum',
        kpis: {
            draft_registers: {
                count: 0,
                icon: 'i-andy-menu-task',
                labelKey: 'radar.module_kpis.draft',
                route: { name: 'Register' },
                severity: 'warning'
            }
        }
    },
    [TOOLS.OPERATIONAL_TIMERS]: {
        key: 'operationalTimers',
        labelKey: 'page_title.Timers',
        icon: 'i-andy-menu-operational-timers',
        apiFormat: 'kpi_array',
        countStrategy: 'templates_length',
        kpis: {
            operational_timers_expired: {
                count: 0,
                icon: 'i-andy-circle-exclamation',
                labelKey: 'radar.module_kpis.expired',
                route: { name: 'Timers' },
                criticalCard: {
                    labelKey: 'radar.critical_cards.operational_timers_expired'
                },
                severity: 'critical'
            }
        }
    }
}

/** Herramientas con KPIs en Radar; base para construir el parámetro tools del API. */
const RADAR_SUPPORTED_TOOL_CODES = RADAR_MODULE_ORDER.filter((toolCode) => {
    return RADAR_MODULE_SCHEMA[toolCode]
})

/** Módulos cuyos KPIs no se piden al API; sus counts vienen de otros módulos de la store. */
const RADAR_LOCAL_ONLY_TOOL_CODES = [TOOLS.PRODUCT_TIMERS, TOOLS.OPERATIONAL_TIMERS]

/**
 * KPIs cuyo count se obtiene de otros módulos de la store (no del API radar).
 *
 * `tasks_to_justify_today` (BUILD-7281) y `tasks_expiring_soon` (BUILD-7290) NO están aquí: aunque
 * se calculan 100% en el frontend, se mantienen en `state.radarKPIs` con el mismo formato
 * kpi_array que `tasks_to_justify_yesterday`, así que ya los recoge `normalizeKpiArrayModule` sin
 * necesitar este override a 0.
 */
const RADAR_STORE_SOURCED_KPIS = {
    [TOOLS.PRODUCT_TIMERS]: ['product_timers_expired', 'product_timers_expiring_soon'],
    [TOOLS.OPERATIONAL_TIMERS]: ['operational_timers_expired']
}

/** Mapeo de toolCode a namespace de módulo Vuex. */
const RADAR_TOOL_STORE_MAP = {
    [TOOLS.CHECKLISTS]: 'tasks',
    [TOOLS.ISSUES]: 'issues',
    [TOOLS.REGISTERS]: 'register',
    [TOOLS.SENSORS]: 'sensor',
    [TOOLS.ACTION_PLANS]: 'actionplan',
    [TOOLS.PRODUCT_TIMERS]: 'timerproduct',
    [TOOLS.OPERATIONAL_TIMERS]: 'timer'
}

/** Indica si el schema del módulo define total (KPIs enriquecidos lo incluirán). */
const moduleSchemaHasTotal = (moduleSchema) => {
    return moduleSchema != null && Object.prototype.hasOwnProperty.call(moduleSchema, 'total')
}

/** Mapeo de toolCode a mutation root para persistir radarKPIs crudos del API. */
const RADAR_API_TOOL_SETTERS = {
    [TOOLS.CHECKLISTS]: 'tasks/setRadarKPIs',
    [TOOLS.ISSUES]: 'issues/setRadarKPIs',
    [TOOLS.REGISTERS]: 'register/setRadarKPIs',
    [TOOLS.SENSORS]: 'sensor/setRadarKPIs',
    [TOOLS.ACTION_PLANS]: 'actionplan/setRadarKPIs'
}

export { RADAR_API_TOOL_SETTERS, RADAR_LOCAL_ONLY_TOOL_CODES, RADAR_MODULE_ORDER, RADAR_MODULE_SCHEMA, RADAR_STORE_SOURCED_KPIS, RADAR_SUPPORTED_TOOL_CODES, RADAR_TOOL_STORE_MAP, moduleSchemaHasTotal }
